import { NewLayoutDrawer } from '@/pages/new-layout-drawer';

export function CreateLayoutPage() {
  return <NewLayoutDrawer mode="create" />;
}
